const dev = {
  url: "https://casemanagement-ops-api-plaza.etoll-dev.idfcfirst.bank.in/api",
  ssoUrl: "https://etolluat.idfcfirst.bank.in/dimtspay_concess",
};
const prod = {
  url: window.location.protocol + "//" + window.location.host + "/api",
  ssoUrl: "https://etoll.idfcfirst.bank.in/dimtspay_concess",
};

const prodMode = process.env.REACT_APP_PROD_MODE === "true";

export const apiEndPoint = prodMode ? prod : dev;
